<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="供应商ID:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.id" placeholder="请输入分类名称">
								</el-input>
							</el-form-item>
							<el-form-item label="供应商名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.supplierName" placeholder="请输入分类名称">
								</el-input>
							</el-form-item>
							<el-form-item label="供应商手机号:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入分类名称">
								</el-input>
							</el-form-item>
							<!-- <el-form-item label="创建时间">
								<div class="block">
									<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
										type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
										:default-time="['00:00:00', '23:59:59']">
									</el-date-picker>
								</div>
							</el-form-item> -->
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="editialogVisible()">新增供应商
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="goodsClassList" style="width: 100%" row-key="id" :header-cell-style="headClass" border lazy
			:tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading="loading"
			element-loading-text="拼命加载中">
			<!-- 
			<el-table-column prop="orderIndex" label="排序级别" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="id" label="供应商ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="supplierName" label="供应商名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="供应商手机号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="address" label="详细地址" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="deltialogVisible(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- <el-pagination style="margin: 20px;" background :current-page="goodsClassList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsClassList.total"
			@size-change="handleSizeChange">
		</el-pagination> -->

		<!-- 查看 -->
		<el-dialog :closeOnClickModal="false" title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="editDialogVisible" width="50%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">

					<el-form-item label="供应商名称">
						<el-input v-model="form.supplierName" style="width: 260px;" placeholder="请输入供应商名称" />
					</el-form-item>
					<el-form-item label="供应商电话号码">
						<el-input v-model="form.phone" style="width: 260px;" placeholder="请输入供应商电话号码" />
					</el-form-item>
					<el-form-item label="供应商详细地址">
						<el-input v-model="form.address" style="width: 260px;" placeholder="请输入供应商详细地址" />
					</el-form-item>

					<el-form-item>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="toEdit()" v-if="this.title=='新增'">新增
						</el-button>
						<el-button type="primary" @click="toEdit()" v-if="this.title=='编辑'">编辑</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		log10
	} from "core-js/library/fn/number";
	export default {
		components: {
			//使用编辑器
			// quillEditor
		},
		data() {
			return {
				title: "",
				classGoods1Id: 0,
				classGoods2Id: 0,
				classGoods1List: [],
				classGoods2List: [],
				imgUrl: urls,
				dialogVisibleImg: false,
				dialogImageUrl: '',
				fileList: [],
				loading: false,
				goodsClassList: [], //商品分类列表
				dialogVisible: false,
				editDialogVisible: false,
				form: {},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				let data = {
					id: this.searchInfo.id,
					phone: this.searchInfo.phone,
					supplierName: this.searchInfo.supplierName,
					// startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					// endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.suppinfoInfo(data).then((res) => { //商品分类列表
					// console.log(res);
					if (res.state == 'success') {
						this.goodsClassList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//选中一级分类
			classGoods1(e) {
				this.classGoods2Id = "";
				if (e) {
					if (this.form.level != 3) {
						this.form.level = 2;
						this.form.pid = e;
						// console.log(e)
						// console.log(this.form)
					}

					this.$api.goodsClassfindByPid(e).then((res) => { //商品二级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				if (e) {
					this.form.pid = e;
					this.form.level = 3;
				}
				// console.log(e)
				// console.log(this.form.pid)

			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				var form = {
					id: this.form.id,
					className: this.form.className,
					level: this.form.level,
					isShow: this.form.isShow,
					image: response.message,
					orderIndex: this.form.orderIndex,
					pid: this.form.pid
				}
				this.form = form;
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//弹框
			editialogVisible(id) {
				this.title = '新增'
				// console.log(id)
				// console.log(this.title)
				if (id) {
					this.title = '编辑';
					//编辑查询
					this.ids = id
					this.$api.suppinfoInfo({
						id
					}).then(res => {
						if (res.state == 'success') {
							this.form = res.data[0]
						}
					})
				} else {
					this.ids = ''
				}
				this.editDialogVisible = true;
			},
			deltialogVisible(id) {
				let data = {
					id
				}
				this.$api.deletesupp(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
						this.findGoodsClassInfo(); //分类列表刷新
					} else {
						this.$message.error(res.message);
					}
				})
			},
			toEdit() {
				if (this.ids) {
					//编辑
					this.$api.pusupp(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.findGoodsClassInfo(); //分类列表刷新
						} else {
							this.$message.error(res.message);
						}
						this.form = ""
					})
				} else {
					//添加
					this.loading = true
					this.$api.Addsupp(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.findGoodsClassInfo();
						} else {
							this.$message.error(res.message);
						}
						this.form = ''
						this.loading = false
					})
				}
			},
			pageChange(data) {
				this.page.pageNum = data
				this.findGoodsClassInfo();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findGoodsClassInfo()
			},
			findGoodsClassInfo() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
				}
				this.$api.suppinfoInfo({}).then((res) => { //商品分类列表
					if (res.state == 'success') {
						this.goodsClassList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			goodsClassfindByPid(row, expanded) {
				// console.log(row, expanded);
				//this.loading2 = true
				this.$api.goodsClassfindByPid(row.id).then((res) => { //根据pid查询商品分类
					// console.log(res);
					if (res.state == 'success') {
						this.goodsClassList2 = res.data
						//this.loading2 = false
					} else {
						this.$message.error(res.message);
					}
				})
			}
		},
		created() {
			this.findGoodsClassInfo();
		},

	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>
